import { Box, Icon } from '@chakra-ui/react';
import { InfoCircle } from '@kula-ai/icons/outline/InfoCircle';

export const InfoCircleIcon = ({ iconColorProp = '' }) => {
  const iconColor = iconColorProp || '242, 153, 74';

  return (
    <Box display="inline-block">
      <Box
        width="36px"
        height="36px"
        borderRadius="full"
        border="2px solid "
        borderColor={`rgba(${iconColor}, 0.15)`}
        display="flex"
        padding="4px"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          width="100%"
          height="100%"
          borderRadius="full"
          border="2px solid"
          display="flex"
          borderColor={`rgba(${iconColor}, 0.3)`}
          alignItems="center"
          justifyContent="center"
        >
          <Icon
            w="16px"
            h="16px"
            as={InfoCircle}
            color={`rgba(${iconColor})`}
          />
        </Box>
      </Box>
    </Box>
  );
};
